export default __webpack_public_path__ + "static/media/ArchiveTimes-DEC2021.00de29fe.png";